import { render, staticRenderFns } from "./RolePropertyTest.vue?vue&type=template&id=35beb2d6"
import script from "./RolePropertyTest.vue?vue&type=script&lang=js"
export * from "./RolePropertyTest.vue?vue&type=script&lang=js"
import style0 from "./RolePropertyTest.vue?vue&type=style&index=0&id=35beb2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports